import { render, staticRenderFns } from "./frontListaImagenes.vue?vue&type=template&id=a1a45bf6&"
import script from "./frontListaImagenes.vue?vue&type=script&lang=js&"
export * from "./frontListaImagenes.vue?vue&type=script&lang=js&"
import style0 from "./frontListaImagenes.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports